import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { Languages } from '~/constants/enums';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    lng: Languages.ARABIC,
    fallbackLng: Languages.ARABIC,
    supportedLngs: [Languages.ARABIC, Languages.ENGLISH],
    interpolation: {
      escapeValue: false,
    },
    react: {
      bindI18n: 'languageChanged',
    },
  });

export default i18n;
